import { addNotify } from 'features/notify';
import { getErrorMessage } from 'shared/utils/getErrorMessage';

const actionTypes = {
  ACTION_PROCESSING: 'tree/ACTION_PROCESSING',
  GET_USERS_BY_USER_ID_SUCCESS: 'tree/GET_USERS_BY_USER_ID_SUCCESS',
  SELECT_AGENT_ID: 'tree/SELECT_AGENT_ID',
  AGENT_CLICKED: 'tree/AGENT_CLICKED',
  SET_PARENT_TREE: 'tree/SET_PARENT_TREE',
  SET_SEARCH_TREE: 'tree/SET_SEARCH_TREE',
};

const setParentTree = parentTree => async (dispatch, getState, extra) => {
  dispatch({
    type: actionTypes.SET_PARENT_TREE,
    payload: parentTree,
  });
};

const setSearchTree = search => async (dispatch, getState, extra) => {
  dispatch({
    type: actionTypes.SET_SEARCH_TREE,
    payload: search,
  });
};

const getUsersByUserId =
  (
    { id, nesting, name, search, mergeWithParentTree } = { nesting: [], mergeWithParentTree: false, search: '' },
    isClickedByButton = false,
  ) =>
  async (dispatch, getState, extra) => {
    const { api } = extra;
    let nestingNumber = 0;
    const { id: userId, isAuth } = getState().auth;
    const { users, parentTree: prevParentTree } = getState().tree;

    if (isAuth) {
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });
      const response = await api.tree.getUsersByUserId({
        id: id || userId,
        targetName: name,
        isClickedByButton,
        search,
      });

      if (response.success) {
        const [children, parentTree] = response.data;

        dispatch(setParentTree(parentTree));

        if (!id) {
          dispatch({
            type: actionTypes.GET_USERS_BY_USER_ID_SUCCESS,
            payload: children,
          });
        } else {
          const mapItem = item => {
            if (item.userId !== +nesting[nestingNumber]) return item;
            if (item.userId === +nesting[nestingNumber] && nestingNumber + 1 === nesting.length) {
              return {
                ...item,
                childrens: children,
              };
            }
            nestingNumber += 1;
            return {
              ...item,
              childrens: item.childrens.map(mapItem),
            };
          };
          const convertedData = users.map(mapItem);
          dispatch({
            type: actionTypes.GET_USERS_BY_USER_ID_SUCCESS,
            payload: convertedData,
          });
        }
      } else {
        const { locale } = getState().locale;
        const errorMessage = getErrorMessage(locale, response);
        dispatch(addNotify(errorMessage, 'error'));
      }
      dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
    }
  };

const banUser =
  ({ id, nesting, value } = { nesting: [] }) =>
  async (dispatch, getState, extra) => {
    const { api } = extra;
    let nestingNumber = 0;
    const { users } = getState().tree;
    const { locale } = getState().locale;
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: true });

    const response = await api.tree.changeUserStateByAction({
      id,
      value,
      name: 'ban',
    });

    if (response.success) {
      const mapItem = item => {
        if (item.userId !== +nesting[nestingNumber]) return item;
        if (item.userId === +nesting[nestingNumber] && nestingNumber + 1 === nesting.length) {
          return {
            ...item,
            isBanned: value,
          };
        }
        nestingNumber += 1;
        return {
          ...item,
          childrens: item.childrens.map(mapItem),
        };
      };
      const convertedData = users.map(mapItem);
      dispatch({
        type: actionTypes.GET_USERS_BY_USER_ID_SUCCESS,
        payload: convertedData,
      });

      const text = value ? locale.banSuccess : locale.unbanSuccess;
      dispatch(addNotify(text, 'success'));
    } else {
      const errorMessage = getErrorMessage(locale, response);
      dispatch(addNotify(errorMessage, 'error'));
    }
    dispatch({ type: actionTypes.ACTION_PROCESSING, payload: false });
  };

const selectAgentId = id => async (dispatch, getState, extra) => {
  dispatch({
    type: actionTypes.SELECT_AGENT_ID,
    payload: id,
  });
};

const agentClickTrigger = () => async (dispatch, getState, extra) => {
  dispatch({
    type: actionTypes.AGENT_CLICKED,
    payload: {},
  });
};

export { actionTypes, getUsersByUserId, banUser, selectAgentId, agentClickTrigger, setParentTree, setSearchTree };
